<template>
  <v-row>
    <v-col cols="12">
      <v-card flat class="mt-3">
        <!-- Previusly we looped through and allows someone to pay multiple subs -->
        <!--         <SubscriptionListItem
          :subscription="subscription"
          v-for="subscription in outstandingSubscriptionInvoices"
          :key="subscription.clientId"
          :routing="false"
          class="mb-4"
          @data_from_child_subs_amount="dataFromChildSubsAmount = $event"
          @data_from_child_covering_payment="
            dataFromChildCoveringPayment = $event
          "
        /> -->

        <SubscriptionListItem
          v-if="invoice"
          :subscription="invoice"
          :routing="false"
          class="mb-4"
        />

        <p
          class="subheading UIAction--text pl-3"
          v-if="coveringPaymentsValue > 0"
        >
          {{ subsAmountFormatted }} (includes
          {{ coveringPaymentAmountFormatted }} covering payment)
        </p>

        <SelectSavedCardsList />

        <v-btn
          block
          color="info"
          :disabled="loading || noSavedCards"
          @click.prevent="paySelectedInvoicesWithSelectedCard"
          >Pay
        </v-btn>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import { formatMoney, formatShortDate } from '&/helpers.js';
import { mapGetters } from 'vuex';

import BackButton from './../BackButton';
import SingleActionView from './../SingleActionView';

import SubscriptionListItem from './../../Subscriptions/SubscriptionListItem';

import SelectOutstandingSubscriptionInvoiceToPayList from './../../Subscriptions/SelectOutstandingSubscriptionInvoiceToPayList';

import SelectSavedCardsList from './../../PaymentManagement/SelectSavedCardsList';

export default {
  name: 'PaySingleOutstandingSubscriptionPayment',
  data() {
    return {
      dataFromChildSubsAmount: null,
      dataFromChildCoveringPayment: null
    };
  },

  props: {
    clientId: {
      required: false,
      type: String
    }
  },

  computed: {
    ...mapGetters([
      'loading',
      'outstandingSubscriptionInvoices',
      'selectedCard',
      'logoUrls',
      'selectedInvoicesToPay',
      'savedCards',
      'paidSubscriptionInvoices'
    ]),

    totalOutstanding() {
      let value = 0;

      for (let key in this.outstandingSubscriptionInvoices) {
        this.outstandingSubscriptionInvoices[key].outstandingInvoice.amount_due
          ? (value += parseInt(
              this.outstandingSubscriptionInvoices[key].outstandingInvoice
                .amount_due
            ))
          : (value += 0);
      }

      return value;
    },

    totalOutstandingSingleSubscription() {
      if (this.invoice) {
        return this.invoice.outstandingInvoice.amount_due;
      }
    },

    subsAmountFormatted() {
      return this.formatMoney(this.totalOutstandingSingleSubscription);
    },

    coveringPaymentAmountFormatted() {
      return this.formatMoney(this.coveringPaymentsValue);
    },

    noSavedCards() {
      return this.savedCards.length === 0;
    },

    coveringPaymentsValue() {
      let total = 0;
      if (this.invoice) {
        for (
          var i = 0;
          i < this.invoice.outstandingInvoice.lines.data.length;
          i++
        ) {
          if (
            !this.invoice.outstandingInvoice.lines.data[i].plan &&
            this.invoice.outstandingInvoice.lines.data[i].object === 'line_item'
          ) {
            total += this.invoice.outstandingInvoice.lines.data[i].amount;
          }
        }
      }
      return total;
    },

    date() {
      let date;
      for (let key in this.outstandingSubscriptionInvoices) {
        date = this.outstandingSubscriptionInvoices[key].outstandingInvoice
          .finalized_at;
      }

      return date;
    },

    totalOutstandingFormatted() {
      return this.formatMoney(this.totalOutstanding);
    },

    clientIds() {
      const clientIds = [];
      for (let key in this.outstandingSubscriptionInvoices) {
        this.outstandingSubscriptionInvoices[key].outstandingInvoice.amount_due
          ? clientIds.push(key)
          : false;
      }
      return clientIds;
    },

    invoice() {
      const clientIds = [];
      for (let key in this.outstandingSubscriptionInvoices) {
        return this.outstandingSubscriptionInvoices[key].outstandingInvoice
          .amount_due
          ? this.outstandingSubscriptionInvoices[key]
          : false;
      }
    }
  },

  methods: {
    formatMoney(value) {
      return formatMoney(value);
    },
    formatShortDate(timestamp, shortForm) {
      return formatShortDate(timestamp, shortForm);
    },

    getLogoUrl(clientId) {
      return this.logoUrls[clientId];
    },

    async paySelectedInvoicesWithSelectedCard() {
      const parameters = {
        savedCard: this.selectedCard.id,
        selectedInvoicesToPay: this.invoice,
      };

      await this.$store.dispatch('PAY_SELECTED_INVOICES_WITH_CARD', parameters);

      if (this.paidSubscriptionInvoices.length > 0) {
        this.$router.push({
          name: 'SubscriptionDetail',
          params: { clientId: this.clientIds[0] }
        });

        this.$emit('dialog', false);
      }
      await this.$store.dispatch('GET_OUTSTANDING_SUBSCRIPTION_INVOICES');
    },
  },

  async created() {
    await this.$store.dispatch('GET_OUTSTANDING_SUBSCRIPTION_INVOICES');
  },
  mounted() {},
  updated() {},

  components: {
    SingleActionView,
    SelectOutstandingSubscriptionInvoiceToPayList,
    SelectSavedCardsList,
    BackButton,
    SubscriptionListItem
  }
};
</script>

<style lang="scss" scoped>
// .bottom-button {
//   position: sticky;
//   position: -webkit-sticky;
//   position: -moz-sticky;
//   position: -ms-sticky;
//   position: -o-sticky;
//   display: grid;
//   bottom: 0 !important;
//   padding: 12px !important;
//   padding-bottom: 16px !important;
//   border-top: 1px solid #efefef !important;
//   background: #efefef !important;

//   .bottom-button-container {
//     display: grid;
//     grid-template-columns: 1fr;
//     // text-align:center;
//     // align-items: center;
//   }
// }
</style>
